import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import ViewClientPanel from './ViewClientPanel';

class ViewClient extends Component {
    constructor(props) {
        super(props);
        this.onBackClick = this.onBackClick.bind(this);
    }

    onBackClick() {
        let { history } = this.props;
        history.push('/client-information');
    }

    render() {
        let { clientInformation } = this.props;
        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );

        const buttonList = [backButton];

        return (
            <div className="col-md-6 mb" style={{padding: 0}}>
                <ViewClientPanel buttons={buttonList} />
                {clientInformation.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ViewClient));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientInformation/screens/ViewClient/index.js